export default __webpack_public_path__ + "static/media/compare_circle.571a3c8b.svg";